import styled from "@emotion/native";
import Text from "../../../Text";
import { TextStyle } from "react-native";

const ASIDE_WIDTH = 30;
const ASIDE_MARGIN_RIGHT = 19;

export const Container = styled.View({
	flexDirection: "row",
	marginBottom: 22,
});

export const Aside = styled.View({
	width: ASIDE_WIDTH,
	height: ASIDE_WIDTH,
	marginRight: ASIDE_MARGIN_RIGHT,
	paddingTop: 3,
});

export const Placeholder = styled.Image({});

export const Main = styled.View({
	flex: 1,
	flexDirection: "column",
	alignItems: "flex-start",
});

export const Label = styled(Text)({}, ({ isLink }: any) => {
	let style: TextStyle = {};

	if (isLink) {
		style = {
			textDecorationLine: "underline",
		};
	}

	return style;
});
